var React = require('react');

function AngleRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128.14 256l56.47 56.49L88.46 409a23.76 23.76 0 0 1-33.6.18l-.18-.18-22.51-22.68a23.92 23.92 0 0 1 0-33.84z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M54.58 103.07L32 125.81a23.92 23.92 0 0 0 0 33.84L184.61 312.5 224 273l.06-.06a24 24 0 0 0-.16-33.94L88.37 103l-.17-.18a23.78 23.78 0 0 0-33.62.22z","className":"fa-primary","key":2})]);
}

AngleRight.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = AngleRight;

AngleRight.default = AngleRight;
